import styled from 'styled-components'

import { Button, IconButton } from '@radix-ui/themes'

export const StyledFiltersHeader = styled.div`
    display: flex;
    align-items: flex-end;
`

export const StyledShowButton = styled(IconButton)``

export const StyledAddButton = styled(Button)``

export const StyledResetButton = styled(Button)`
    margin-left: 0.5rem;
    height: 100%;
    padding-block: 0.2rem;
`

export const StyledPinnedFilters = styled.div`
    display: flex;
    gap: 1rem;
    margin-left: 1rem;
    color: var(--accent-a11);

    > div {
        height: 100%;

        label {
            display: block;
        }

        input {
            padding: 0.2rem;
            border: 1px solid var(--accent-a7);
            border-radius: max(var(--radius-2), var(--radius-full));
            height: 100%;

            &:hover {
                box-shadow: inset 0 0 0 1px var(--accent-a8);
            }
        }

        .react-select-primitive {
            > div:first-of-type {
                min-height: auto !important;

                > div {
                    padding-block: 0 !important;
                    > div {
                        padding-block: 0.1rem !important;
                    }
                }
            }
        }
    }
`
